import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../modals/confirm-modal/confirm-modal.component';
import { UpdateUserEmailComponent } from '../../modals/user-modal/update-user-email.component';
import { PromptModalComponent } from '../../prompt-modal/prompt-modal.component';
import { FirebaseService } from '../../service/firebase.service';
import { UserCreationModalComponent } from '../../user-creation-modal/user-creation-modal.component';
import { v4 as uuidv4 } from 'uuid';
import { group } from '@angular/animations';
import { ModalTextComponent } from '../../modals/modal-text/modal-text.component';
import { ServerService } from '../../modules/usermanagement/server.service';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss']
})
export class UserCardComponent implements OnInit {
  modulesArray: any = [{ name: 'kiosk' }, {name: 'solokiosk'}, { name: 'quiz' }, { name: 'selfie' },
    { name: 'lottery' }, { name: 'data' }, { name: 'media' }, {name: 'mediaLimiter'},
    { name: 'mapcontent' }, { name: 'wayfinding' }]
  constructor(public firebaseService: FirebaseService, public dialog: MatDialog, private serverService: ServerService ,private _ref: ChangeDetectorRef, private _http: HttpClient, private storage: AngularFireStorage) { }
  @Input('user') user;
  @Input('groups') groups;
  @Input('devices') devices;
  @Input('licences') licences
  ngOnInit(): void {
    console.log(this.groups);
    // console.log("LICENCES", this.licences)


    if (this.licences) {
      this.licences.forEach(item => {
        //  item.startDate = item.
      })
    }
  }


  /**
   * Delete selected user
   * @param id user id
   */
  deleteUser(id) {
    if (confirm('Voulez vous supprimer cet utilisateur')) {
      //console.log(id)
     this.serverService.deleteUser(id)
      //this.firebaseService.deleteUser(id)
    }
    else {

    }

  }

  resetPassword(email) {
    this.serverService.getUserPasswordResetLink(email).then((d:any) => {
      alert(d)
    window.open(d, '_blank')
    })
  }

  updateUserValue(key, val) {

    let data = {}

    data[key] = val

    this.firebaseService.updateUserData(data, this.user.id).then(d => { }).catch(err => { console.log(err) })
  }

  removeIdDevice(i, type) {
    this.licences.find(e => e.type == type).listDevice.splice(i, 1);

    this.updateUserValue('licence', this.licences)
  }

  updatePassword(user, str) {
    this.firebaseService.updateUserPassword(user, str)
  }

  updateEmailPopUp(oldEmail) {
    let dialogRef = this.dialog.open(UpdateUserEmailComponent, {
      height: '400px',
      width: '600px',
    });


    dialogRef.afterClosed().subscribe(result => {
      this.firebaseService.updateUserEmail(oldEmail, result.email, result.password)
    });


  }

  mergeTypedArrays(a, b) {
    // Checks for truthy values on both arrays 
    if (!a && !b) throw 'Please specify valid arguments for parameters a and b.';

    // Checks for truthy values or empty arrays on each argument 
    // to avoid the unnecessary construction of a new array and 
    // the type comparison 
    if (!b || b.length === 0) return a;
    if (!a || a.length === 0) return b;

    // Make sure that both typed arrays are of the same type 
    if (Object.prototype.toString.call(a) !== Object.prototype.toString.call(b))
      throw 'The types of the two arguments passed for parameters a and b do not match.';

    var c = new a.constructor(a.length + b.length);
    c.set(a);
    c.set(b, a.length);

    return c;
  }

  /**
 * Remove device from local and Firestore
 * @param device selected device
 */
  deleteDevice(device) {


    let dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: {
        title: 'Êtes-vous sûr de vouloir supprimer cette borne ? (Cette action est irréversible)'
      }
    })


    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.devices.forEach((item, index, object) => {
          if (item == device) {
            object.splice(index, 1)
            this.firebaseService.deleteDevice(device)
          }
        })
    })

  }

  /**
   * Delete group from local and Firestore
   * @param groupName selected groupName
   */
  deleteGroup(groupName, id) {

    let dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '30vw',
      height: '30vh',
      data: {
        title: 'Êtes-vous sûr de vouloir supprimer cet groupe ? (Cette action est irréversible)'
      }
    })

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.groups.forEach((item, index, object) => {
          if (item.name == groupName && item.parent == id) {
            object.splice(index, 1)


            // console.log(item)
            this.firebaseService.deleteGroup(groupName, id)
          }

        })
    })



  }


  /**
   * Create new group
   * @param user selected user
   */
  addGroup(user) {

    this.openDialog('groupCreation', (groupName) => {
      if (groupName != undefined && groupName != '') {

        this.firebaseService.addGroup(groupName, user).then((d) => {
          this.groups.push({ name: groupName, parent: user.uid, id: d.id })
          //   console.log(this.groups)
        });
      }
    });
  }



  /**
 * Update device's module
 * @param module Module data
 * @param e value
 * @param device Device data
 * @param user active user
 */
  deviceModules(module, e, device, user) {
    console.log(device)
    //  console.log("TRIGGER", device, device.data.modules, e.target.checked)
    if (device.data.modules == undefined)
      device.data.modules = {};
    device.data.modules[module.name] = e.target.checked
    //  device.groupId = "test";
    let currentContainer = e.target.parentNode.parentNode.parentNode;


    //console.log(currentContainer.querySelectorAll('input'))

    let inputs = currentContainer.querySelectorAll('input')

    if (module.name == 'lottery' && e.target.checked) {
      for (let item in inputs) {
        let elem = inputs[item]
        //console.log(elem.name)

        //    console.log(elem, device.data.modules)
        if (device.data.modules == undefined)
          device.data.modules = {};

        if (elem.name == "data") {
          elem.setAttribute("checked", "true");

          device.data.modules['data'] = true;
          //   this.firebaseService.updateDevice({ name: 'data' }, elem.checked, device, user.uid)
        }

        if (elem.name == "quiz") {
          elem.setAttribute("checked", "true");
          device.data.modules['quiz'] = true;
          //  this.firebaseService.updateDevice({ name: 'quiz' }, elem.checked, device, user.uid)
        }

        device.data.modules['lottery'] = true;
      }





    }

    this.firebaseService.updateDevice(module, e.target.checked, device, user.uid).then(d => {
      //  console.log(d)
      /*IF LOTTERY ENABLE, CREATE DATA AND QUIZ MODULE */
      if (module.name == 'lottery' && e.target.checked) {

        this.firebaseService.getModuleFromDeviceFromUser('lottery', device.data.group, device.data.name, user.id).then(lotConf => {
          let promiseArray = [];

          //console.log(lotConf.data.config.sound.loop.data)
          if (!lotConf.data.config.sound.loop || lotConf.data.config.sound.loop.data.name == null)
            promiseArray.push(this.addLotteryDefaultSoundElement('ambiance_default.mp3', 'loop', user, device))
          if (!lotConf.data.config.sound.win || lotConf.data.config.sound.win.data.name == null)
            promiseArray.push(this.addLotteryDefaultSoundElement('win_default.mp3', 'win', user, device))
          if (!lotConf.data.config.sound.lose || lotConf.data.config.sound.lose.data.name == null)
            promiseArray.push(this.addLotteryDefaultSoundElement('loose_default.mp3', 'lose', user, device))


          Promise.all(promiseArray).then(d => {
            d.forEach((item) => {
              lotConf.data.config.sound[item.type] = {
                enable: false,
                data: { url: item.url, name: item.filename }
              }
            })


            this.firebaseService.updateModule(lotConf.id, lotConf.data)

          })
        })




        console.log("MODULE ELEMENT", module)
        if (device.data.modules.data != undefined && device.data.modules.data) {
          this.firebaseService.updateDevice({ name: 'data' }, true, device, user.uid).then(d => { })
        }
        if (device.data.modules.quiz != undefined && device.data.modules.quiz) {
          this.firebaseService.updateDevice({ name: 'quiz' }, true, device, user.uid).then(d => { })
        }

      }
    })


  }


  updateDeviceHideState(device, user) {

    //console.log(device, user)

    this.firebaseService.updateDeviceById(device.id, { hideDevice: device.data.hideDevice });
    // this.firebaseService.updateConfigDevice(device.data.config.config, device.id)
  }



  /**
   * Add default sound element element when 
   * @param ref
   * @param path
   * @param user
   * @param borneName
   * @param groupName
   */

  addLotteryDefaultSoundElement(ref, type, user, device) {

    let filename = `${uuidv4()}.mp3`;
    let path = `users/${user.displayName}/sound/${filename}`

    return new Promise<any>((resolve, reject) => {
      let that = this;
      this.storage.ref(ref).getDownloadURL().toPromise().then(d => {
        //   console.log(d)
        let fileArray = new Uint8Array()
        fetch(d).then(htmlReturn => {
          const reader = htmlReturn.body.getReader();


          // console.log(reader)
          reader
            .read()
            .then(function appendStreamChunk({ done, value }) {
              //If the reader doesn't return "done = true" append the chunk that was returned to us
              // rinse and repeat until it is done.
              if (value) {
                fileArray = that.mergeTypedArrays(fileArray, value)
              }
              if (done) {
                //  console.log(fileArray)
                return fileArray
              } else {
                // "Readout not complete, reading next chunk"
                return reader.read().then(appendStreamChunk)
              }
            })
            .then(file => {
              //Write the file to the new storage place
              //   console.log(user)

              let status = this.storage.upload(path, file).then(() => {
                this.storage.ref(path).getDownloadURL().toPromise().then(d => {
                  resolve({ url: d, filename: filename, type: type })
                  /* this.firebaseService.getModuleDataFromUserAndType(user.uid, 'lottery').then(lotConf => {
                     console.log(lotConf.docs.map(v => v.data()))
                   })*/

                  //   let soundData =
                  /*  this.firebaseService.getModuleFromDevice('lottery', groupName, borneName).then(a => {
                      console.log(a)
                    })*/
                })


              })
            })
        })
      })
    })


  }


  /**
   * Add default media
   * @param ref
   * @param path
   */

  addMediaDefault(ref, path, user, borneName, groupName, groupId) {
    let that = this;
    this.storage.ref(ref).getDownloadURL().toPromise().then(d => {
      //   console.log(d)
      let fileArray = new Uint8Array()
      fetch(d).then(htmlReturn => {
        const reader = htmlReturn.body.getReader();


        // console.log(reader)
        reader
          .read()
          .then(function appendStreamChunk({ done, value }) {
            //If the reader doesn't return "done = true" append the chunk that was returned to us
            // rinse and repeat until it is done.
            if (value) {
              fileArray = that.mergeTypedArrays(fileArray, value)
            }
            if (done) {
              //  console.log(fileArray)
              return fileArray
            } else {
              // "Readout not complete, reading next chunk"
              return reader.read().then(appendStreamChunk)
            }
          })
          .then(file => {
            //Write the file to the new storage place
            //   console.log(user)

            let status = this.storage.upload(path, file).then(() => {
              this.storage.ref(path).getDownloadURL().toPromise().then(d => {
                this.firebaseService.addDevice({ parent: user.uid, name: borneName, activeAnim: true, activeDate: true, activeText: true, activeTextBackground: false, activeWeather: false, group: groupName, groupId: groupId, backgroundURL: d, listBackgrounds: [d] }, user).then(id => {
                  this.devices.push({ id: id, data: { parent: user.uid, name: borneName, group: groupName } })

                  this._ref.detectChanges();
                })
              })


            })
          })
      })
    })
  }


  /**
   * Create new device
   * @param user active user
   * @param groupName selected groupName
   */
  addDevice(user, groupName, groupId) {

    console.log(this.groups, user, groupName, groupId)
    this.openDialog('deviceCreation', (borneName) => {
      if (borneName != undefined && borneName != '') {
        let that = this;
        let backgroundFilename = uuidv4()


        this.firebaseService.checkIfDeviceExist(borneName, groupName, groupId).get().then(d => {
          let devices = d.docs.map(v => { return { id: v.id, data: v.data() } })

          console.log(devices.length)
          if (devices.length > 0) {
            console.log("ALREADY EXIST")
            this.dialog.open(ModalTextComponent, {
              width: '30vw',
              height: '30vh',
              data: 'Une borne du même nom existe déjà, veuillez changer de nom.'
            })
          }
          else {
            console.log("CREATE DEVICE")
            this.addMediaDefault('default_background.jpg', `users/${user.displayName}/baseConfig/backgrounds/${backgroundFilename}.jpg`, user, borneName, groupName, groupId)

          }

        }).catch(err => {

        })

      }

    });

  }


  /**
 * Open dialog
 * @param type The modal's dialog
 * @param callback
 */
  openDialog(type, callback = (res) => { }): void {
    let dialogRef: any;

    switch (type) {
      case 'userCreation':
        dialogRef = this.dialog.open(UserCreationModalComponent, {
          width: '30vw',
          height: '40vh',
          data: {}
        });
        break;
      case 'deviceCreation':
        dialogRef = this.dialog.open(PromptModalComponent, {
          width: '30vw',
          height: '30vh',
          data: { title: 'Veuillez entrer un nom de borne' }
        });
        break;
      case 'deviceSuppression':
        dialogRef = this.dialog.open(ConfirmModalComponent, {
          width: '30vw',
          height: '30vh',
          data: { title: 'Êtes-vous sûr de vouloir supprimer cette borne ?' }
        });
        break;
      case 'groupCreation':
        dialogRef = this.dialog.open(PromptModalComponent, {
          width: '30vw',
          height: '30vh',
          data: { title: 'Veuillez entrer un nom de groupe' }
        })
        break;
      /* case 'groupSuppression':
         dialogRef = this.dialog.open()
         break;*/

    }
    dialogRef.afterClosed().subscribe(result => {
      callback(result)
    });
  }
}
